var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.29 3c.298 2.554 1.73 4.077 4.22 4.24v2.873c-1.442.14-2.706-.33-4.177-1.216v5.374c0 6.826-7.475 8.96-10.481 4.066-1.931-3.148-.749-8.673 5.447-8.894v3.03a8.988 8.988 0 0 0-1.438.35c-1.378.465-2.16 1.335-1.942 2.868.418 2.938 5.832 3.808 5.382-1.933V3.005h2.989V3Z",
  fill: "#fff"
})));
export default SvgTiktok;